module.exports = require("./hr.d.ts");